/**
 * gilPrompts.js - Pre-canned GIL prompts for Proactive GIL nudges
 * 
 * GOVERNANCE BOUNDARY:
 * - AI explains; AI never decides
 * - No recommendations, no approvals
 * - Plain-language explanations only
 */

// Page-specific GIL prompts
export const GIL_PROMPTS = {
  // Homepage prompts
  home: {
    default: "Summarize what Granullo does and does not do.",
    hesitation: "Want a 10-second explanation of what you're seeing?",
    scroll_stall: "I can explain how Granullo's governance layer works.",
  },
  
  // Possibilities / Scenarios
  possibilities: {
    default: "Explain the governance lifecycle and who is responsible for what.",
    hesitation: "Need help understanding these governance scenarios?",
    back_forth: "I can summarize the key differences between these scenarios.",
  },
  
  // Corporate Programs
  corporate_programs: {
    default: "Explain how corporate program governance works.",
    hesitation: "Want me to explain eligibility rules and policy versioning?",
    repeated_tooltips: "I can clarify what governance boundaries mean for this program.",
  },
  
  // Program detail pages
  program_detail: {
    default: "Explain how decisions are recorded and what deviations mean.",
    hesitation: "I can break down the governance lifecycle for this program.",
    scroll_stall: "Need help understanding the policy versioning section?",
  },
  
  // Bank merchants
  bank_merchants: {
    default: "Explain bulk upload and governance boundaries.",
    hesitation: "I can explain the merchant governance workflow.",
    error_encountered: "Something went wrong. Want me to explain what you can do?",
  },
  
  // How Granullo Works
  how_it_works: {
    default: "I can simplify any concept on this page.",
    hesitation: "Want a plain-language summary of how governance works?",
    scroll_stall: "I can explain this section in simpler terms.",
  },
  
  // UBI Governance
  ubi_governance: {
    default: "Explain how UBI governance differs from traditional programs.",
    hesitation: "I can clarify the public finance governance model.",
  },
  
  // Learning Hub
  learning: {
    default: "What would you like to learn about governance?",
    hesitation: "I can recommend a learning path based on your role.",
  },
  
  // Glossary
  glossary: {
    default: "Looking for a specific term? I can help.",
    hesitation: "I can explain any governance concept in plain language.",
  },
  
  // Fallback
  fallback: {
    default: "I can help explain what you're looking at.",
    hesitation: "Need a quick explanation?",
  },
};

// Get prompt for page and signal
export const getGilPrompt = (pageType, signal = 'default') => {
  const pagePrompts = GIL_PROMPTS[pageType] || GIL_PROMPTS.fallback;
  return pagePrompts[signal] || pagePrompts.default;
};

// Map route to page type
export const getPageTypeFromRoute = (pathname) => {
  if (pathname === '/' || pathname === '/home') return 'home';
  if (pathname.startsWith('/possibilities/corporate')) return 'corporate_programs';
  if (pathname.startsWith('/possibilities/')) return 'program_detail';
  if (pathname === '/possibilities') return 'possibilities';
  if (pathname.startsWith('/bank/')) return 'bank_merchants';
  if (pathname === '/how-granullo-works') return 'how_it_works';
  if (pathname === '/ubi-governance') return 'ubi_governance';
  if (pathname.startsWith('/learn')) return 'learning';
  if (pathname === '/glossary') return 'glossary';
  return 'fallback';
};

export default GIL_PROMPTS;
